import styled from "styled-components"

const Container =styled.div`
  width:80%;
  max-width:100%;
  padding:0 20px;
  margin:auto;
  padding:40px 0;
  
`
export default Container